/**
 * Pattern for detecting the presence of a placeholder in a string
 * @example
 *  Here are some matching values
 *  {{ subscription.customer.firstName }}
 *  {{hello.world    }}
 *  {{ subscription.initialInvoice.subtotalAmount | money }}
 *  {{invoice.customer.primaryAddress.emails.0.value}}
 *  {{ subscription.initialInvoice.currency }}
 * @type {RegExp}
 */
const placeholderPattern = /\{{\s*(\w[\d\w.]+\w)(\s*\|.+)?\s*\}}/g;

export default placeholderPattern;
